import { render } from "./tw-ws-title.vue?vue&type=template&id=fa054fa6"
import script from "./tw-ws-title.vue?vue&type=script&lang=js"
export * from "./tw-ws-title.vue?vue&type=script&lang=js"
script.render = render

export default script